import React from 'react';
import { View } from 'react-native';
import { schedulers } from '@qnpm/q-pkgs-slugger/src/schedule';
import { OP_NEXT_DRAWFRAME } from '@qnpm/q-pkgs-slugger';

const UPDATE_PROPS_PENDING_UPDATE = 1;
const UPDATE_COMMITIED = 2;

export default class QSlugger extends React.Component {
    updateState;

    constructor(props) {
        super(props);
        this.state = {};
        const { target } = props;
        if (target) {
            this.displayName = target.displayName || target.constructor.displayName || target.constructor.name;
        }
    }
    
    componentWillReceiveProps(nextProps) {
        this.updateState = UPDATE_PROPS_PENDING_UPDATE;
        const commit = schedulers[nextProps.schedule || OP_NEXT_DRAWFRAME];
        commit(() => {
            if (this.willUnmount) {
                return;
            }
            this.updateState = UPDATE_COMMITIED;
            this.setState({
                childrenProps: nextProps
            });
        });
    }

    shouldComponentUpdate() {
        return this.updateState !== UPDATE_PROPS_PENDING_UPDATE;
    }

    componentDidMount() {
        setTimeout(() => {
            // 下一帧再触发渲染
            this.setState({ didMount: true });
        }, 0);
    }

    componentWillUnMount() {
        this.willUnmount = true;
    }

    render() {
        const { target: Target, placeholder, innerRef } = this.props;
        if (!this.state.didMount) {
            return placeholder ? <View style={placeholder} /> : null;
        }
        return <Target {...this.props} ref={innerRef}/>;
    }
}
